import React, { useState } from "react";
import { supabase } from "../utils/supabaseClient";

export default function MagicLinkLogin() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendLink = async (addr) => {
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.signInWithOtp({
      email: addr,
      options: {
        emailRedirectTo: `${window.location.origin}/app`,
      },
    });
    setLoading(false);
    if (error) {
      setError(error.message);
    } else {
      // Store email so /app can identify the user the moment they land
      localStorage.setItem("buddee-userEmail", addr);
      setSent(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sendLink(email);
  };

  if (sent) {
    return (
      <div className="text-center space-y-3">
        <p className="text-sage-900 font-bold text-lg mb-1">Check your email!</p>
        <p className="text-sm text-sage-900/60">
          We sent a magic link to <strong>{email}</strong>. Click it to sign in.
        </p>
        <button
          onClick={() => sendLink(email)}
          disabled={loading}
          className="text-xs underline underline-offset-2 text-sage-900/50 hover:text-sage-900/80 transition disabled:opacity-40"
        >
          {loading ? "Sending…" : "Resend link"}
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col items-center gap-3 w-full max-w-sm">
      <input
        type="email"
        placeholder="your@email.com"
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
        className="w-full px-4 py-3 rounded-xl border border-sage-900 bg-white text-sage-900 placeholder-zinc-400 text-sm focus:outline-none focus:ring-2 focus:ring-sage-900"
      />
      {error && <p className="text-red-600 text-sm">{error}</p>}
      <button
        type="submit"
        disabled={loading}
        className="w-full px-6 py-3 bg-sage-900 text-white font-bold rounded-xl hover:opacity-90 transition disabled:opacity-50"
      >
        {loading ? "Sending…" : "Send Magic Link"}
      </button>
    </form>
  );
}
